import { PaperSizeEnum } from "@/common/enum/paper-size";

export class PrintUtils {
  public static hasPaperSizeOption() {
    if (obj_Printer_Core && obj_Printer_Core.hasPaperSizeOption) {
      return obj_Printer_Core.hasPaperSizeOption();
    }
    return false;
  }

  public static buildTemplateNameByPaperSize(name: string, paperSize: string) {
    if (paperSize === PaperSizeEnum.Paper_100_70) {
      name += ("_" +PaperSizeEnum.Paper_100_70);
    }

    return name;
  }

  public static getDefaultPaperSize() {
    const defaultPaperSize = PaperSizeEnum.Paper_100_70;
    try {
      const configStr = obj_System_Core.getYtoCommonConfig();
      const config = JSON.parse(configStr);
      return config.LastPaperSize || defaultPaperSize;
    } catch {
      return defaultPaperSize;
    }
  }

  public static savePaperSize(paperSize) {
    obj_System_Core && obj_System_Core.saveYtoCommonConfig({
      LastPaperSize: paperSize,
    });
  }

  public static hasThreeCodeSearch(){
    if (obj_Printer_Core && obj_Printer_Core.hasThreeCodeSearch) {
      return obj_Printer_Core.hasThreeCodeSearch();
    }
    return false;
  }
}
